import React from 'react';
import Highcharts from 'highcharts';
import { useRecoilValueLoadable } from 'recoil';
import { agentSummary } from '../../../recoil/selectors/agentSummary';
import { HighchartsReactWithStyles } from './HighchartsReactWithStyles';

export function AgentReportsChart() {
  const agentsSummary = useRecoilValueLoadable(agentSummary);
  const summary = agentsSummary?.contents?.options || {};

  return (
    <div>
      <HighchartsReactWithStyles
        allowChartUpdate={true}
        highcharts={Highcharts}
        options={JSON.parse(JSON.stringify(summary ?? null))}
        loading={agentsSummary.state === 'loading'}
      />
    </div>
  );
}
